import Image from 'next/image'

import cl from './BigHeroBanner.module.scss'

export const BigHeroBanner = ({
	image,
	text,
	title,
	additional
}: {
	image: string
	text: string
	title: string
	additional: { title: string; text: string }[]
}) => {
	return (
		<section className={cl.main}>
			<div className={cl.header}>
				<div className={cl.textWrapper}>
					<h2 className={cl.title}>{title}</h2>
					<p className={cl.subtitle}>{text}</p>
				</div>
				<Image src={image} width={702} height={468} className={cl.img} alt={title} priority />
			</div>
			<div className={cl.footer}>
				<ul className={cl.footerList}>
					{additional &&
						additional.map((item, index) => (
							<li key={index} className={cl.footerItem}>
								<h4 className={cl.addTitle}>{item.title}</h4>
								<p className={cl.addSubtitle}>{item.text}</p>
							</li>
						))}
				</ul>
			</div>
		</section>
	)
}
